<template>
  <v-dialog v-model="dialog"
            width="400px"
            @click:outside="closeDialog">
    <v-form @submit.prevent="switchToTeam"
            :disabled="form.busy || teamsLoading">
      <v-card flat
              tile>
        <v-card-title>
          Switch Team
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="form.team"
                          label="Team"
                          :items="activeTeams"
                          item-value="id"
                          item-text="name"
                          return-object
                          outlined
                          dense
                          :error-messages="form.errors.get('team_id')">
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy || !isFormValid">
            Switch Team
          </v-btn>
          <v-btn @click.prevent="closeDialog"
                 text>
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :to="{name: 'admin.teams.index'}"
                 @click="closeDialog"
                 text>
            View List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import userService from '../../../services/userService';
import DOMPurify from 'dompurify';
import {isObject} from 'lodash';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        team: null,
      })
    }
  },
  computed: {
    ...mapGetters([
      'activeTeams',
      'teamsLoading',
      'user',
    ]),
    isFormValid() {
      return isObject(this.form.team) !== false
        && this.teamsLoading === false
        && this.activeTeams.length > 1;
    }
  },
  methods: {
    async switchToTeam() {
      if (this.teamsLoading) {
        return;
      }
      if (this.form.busy) {
        return;
      }
      if (this.isFormValid === false) {
        return;
      }
      try {
        this.form.startProcessing();
        await userService.switchUserToTeam(this.user.id, this.form.team.id)
        window.localStorage.clear();
        window.sessionStorage.clear();
        this.$emit('updated');
        this.$toast.success(`Switched to ${DOMPurify.sanitize(this.form.team.name)}`);
        this.closeDialog();
        location.reload();
      } catch (error) {
        this.$toast.error('You cannot switch to that team.');
      } finally {
        this.form.busy = false;
      }
    },
    closeDialog() {
      this.$emit('close');
    }
  }
}
</script>
